import Badge from '../../../../components/primitives/Badge.jsx';
import ExecutionStatus from '../../../../components/surfaces/ExecutionStatus.jsx';
import GalleryExample from './GalleryExample.jsx';
import GallerySection from './GallerySection.jsx';
import RunExampleCard from './RunExampleCard.jsx';

const StatusSection = () => {
  return (
    <GallerySection id="status" title="Execution states" description="Every piece of work says where it stands. Each state has its own shape and words, so it reads without color.">
      <GalleryExample label="Status">
        <ExecutionStatus state="queued" />
        <ExecutionStatus state="running" />
        <ExecutionStatus state="waiting" />
        <ExecutionStatus state="done" />
        <ExecutionStatus state="failed" />
      </GalleryExample>
      <GalleryExample label="With detail, small">
        <ExecutionStatus state="running" detail="Step 2 of 4" size="sm" />
        <ExecutionStatus state="waiting" detail="Approve 3 emails" size="sm" />
        <ExecutionStatus state="done" detail="12:04" size="sm" />
        <ExecutionStatus state="failed" detail="Gmail token expired" size="sm" />
      </GalleryExample>
      <GalleryExample label="Badges">
        <Badge>Draft</Badge>
        <Badge tone="brand">Scheduled</Badge>
        <Badge tone="success">Connected</Badge>
        <Badge tone="warning">Needs review</Badge>
        <Badge tone="danger">Disconnected</Badge>
        <Badge tone="info">Beta</Badge>
        <Badge mono>v14</Badge>
      </GalleryExample>
      <RunExampleCard />
    </GallerySection>
  );
};

export default StatusSection;
